export default "__VITE_ASSET__BBKJ4GvT__"